<template src="./html/Datatable.html"></template>

<script>
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import Export from './../../export/Export.vue'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'statuses'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'loading': VueElementLoading,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/teams/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: 'id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:teams_name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:teams_staff',
							title: 'Personal',
						},
						{
							name: '__slot:teams_author',
							title: 'Autor',
							sortField: 'author_id',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:teams_actions',
							title: '',
						},
					],
				},
			}
		},
		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			filterReset() {
				this.clearFilter()
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
			},
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/projects/teams/views/Datatable.vue